"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Encounter_Hospitalization = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
exports.RTTI_Encounter_Hospitalization = t.recursion('IEncounter_Hospitalization', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        preAdmissionIdentifier: RTTI_Identifier_1.RTTI_Identifier,
        origin: RTTI_Reference_1.RTTI_Reference,
        admitSource: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        reAdmission: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        dietPreference: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        specialCourtesy: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        specialArrangement: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        destination: RTTI_Reference_1.RTTI_Reference,
        dischargeDisposition: RTTI_CodeableConcept_1.RTTI_CodeableConcept
    });
});
//# sourceMappingURL=RTTI_Encounter_Hospitalization.js.map